import { Component } from '@angular/core';

@Component({
  selector: 'app-site-description',
  templateUrl: './site-description.component.html',
  styleUrls: ['./site-description.component.scss']
})
export class SiteDescriptionComponent {

}
